// src/components/ImageSectionVert.js
import React from "react";
import "./ImageSectionVert.css";
import imageLeft from "../assets/img/441AR_EXTERIOR DIA.jpg"; // Your left image
import imageRight from "../assets/img/Unknown.jpg"; // Your right image

const ImageSectionVert = () => {
  return (
    <section className="image-section-vert">
      <div className="image-container">
        <div className="image-left">
          <img src={imageLeft} alt="Left view" className="vert-image" />
        </div>
        <div className="image-right">
          <img src={imageRight} alt="Right view" className="vert-image" />
        </div>
      </div>
    </section>
  );
};

export default ImageSectionVert;
